import { useEffect } from "react"

import ReactGA from "react-ga"
import { useLocation } from "react-router-dom"

export const useGoogleAnalytics = (trackingId: string | undefined): void => {
	useEffect(() => {
		if (trackingId !== undefined) {
			ReactGA.initialize(trackingId)
		}
	}, [trackingId])

	const location = useLocation()

	useEffect(() => {
		if (trackingId !== undefined) {
			ReactGA.pageview(location.pathname)
		}
	}, [location, trackingId])
}
